import React from 'react';
const coverage = [{
  label: 'Block 1 · Warm-up',
  body: 'Joint-by-joint prep and movement warm-ups that ready parkour bodies'
}, {
  label: 'Block 2 · Skill + regression',
  body: 'The skill of the day with a built-in easier lane, so no student gets stuck'
}, {
  label: 'Block 3 · Game',
  body: 'A challenge that burns energy and covers waiting time — no bored kids in line'
}, {
  label: 'Block 4 · Cool-down',
  body: 'A calm close and a quick check before the group leaves'
}, {
  label: 'Every session',
  body: 'Setup, gear (+ no-gear variant), group split, cues, the common error and its fix'
}, {
  label: 'Every group',
  body: 'Adapt notes for kids, teens and rec groups, plus an easier / harder dial'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-185" data-mp="2iae2lcv32v30">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-186" data-mp="1pnteqmdth147">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-187" data-mp="1plp8hxsg3q0r">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-188" data-mp="1f2j4stncazo8">
          The Ready-Run Session System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-189" data-mp="1oscfztjklcry">
          Most parkour resources hand you moves, drills or game ideas — and leave
          the planning to you. Every week you still pick a skill, build a warm-up,
          find a game for the queue, decide what the beginner does instead and fit
          it all into the hour. The Ready-Run Session System does that work once,
          in advance: every class comes in the same four fixed blocks, placed on a
          progression ladder that covers the year. You don&apos;t design the
          class. You pick today&apos;s session and run it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="2hfq6p9wodc3m">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-191" data-mp="1rr198vovz7bt">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-192" data-mp="21qs6v68qu2g4">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-193" data-mp="1wsi70ic2qdo6">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}